import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import type { ReactNode } from 'react';
import { SectionHeading } from './SectionHeading';

interface InfoCardProps {
  title: string;
  children: ReactNode;
}

/**
 * Reusable card panel for sidebar sections (user info, groups, settings, etc.)
 */
export function InfoCard({ title, children }: InfoCardProps) {
  return (
    <Card>
      <CardContent>
        <SectionHeading className="block mb-1">{title}</SectionHeading>
        {children}
      </CardContent>
    </Card>
  );
}
